<template>
  <SkyImage
    :alt="alt"
    :src="imageSrcSets[0].src"
    :srcsets="imageSrcSets"
  />
</template>

<script setup lang="ts">
import { SkyImage } from '@groveco/skylight'

type SkyImageInstance = InstanceType<typeof SkyImage>
type SrcSets = SkyImageInstance['srcsets']

const baseTransforms = 'f_auto,q_auto:low,fl_progressive'

const props = defineProps({
  src: {
    type: String,
    default: '',
  },
  alt: {
    type: String,
    default: '',
  }
})

const imageSrcSets = computed<SrcSets>(() => {
  const imageUrl = props.src.startsWith('//') ? `https://${props.src.slice(2)}` : props.src

  return [672, 1344].map((width) => ({
    width,
    src: transformImage(imageUrl, `${baseTransforms},w_${width}`),
  }))
})
</script>
